import "./account.css"
import acc_landing_logo from "../../../assets/account_landing_logo.webp"
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {setAccountType, setSelectedLabel, setSelectedOption, setDayTrade} from '../../../redux/account_store';
import {setPersonalData} from "../../../redux/personal_store";
import {connect} from 'react-redux';
import {useTranslation} from "react-i18next";
import Logout from "../../logout/Logout";
import CashMarginTooltip from "../../state_tooltip/CashMarginTooltip";
import CashTooltip from "../../state_tooltip/CashTooltip";
import ProgressBar from "react-bootstrap/ProgressBar";

function AccountInfo({
                         accountType,
                         setAccountType,
                         dayTrade,
                         setDayTrade,
                         selectedOption,
                         setSelectedOption,
                         setSelectedLabel,
                         appData,
                         financialInfo,
                         personalData
                     }) {

    const [isCashError, setIsCashError] = useState(false);

    let backTo = '/affiliation'
    if (appData.account_type === 'custodial') backTo = '/custodial-account'
    if (appData.account_type === 'speciality') backTo = '/authorized-signers'
    let now

    if (appData.account_type === "custodial" || appData.account_type === "speciality") {
        now = 55
    } else {
        now = 50
    }

    const {t} = useTranslation()

    const handleAccountChange = (newAccountType) => {
        if (appData.hear_about_us === "DAWUL") {
            return;
        }

        if (newAccountType === 'marginAcc' && appData.account_type === 'IRA') {
            return;
        }

        if (financialInfo.assets === 'A') {
            if (newAccountType === 'marginAcc') {
                setIsCashError(true)
            } else {
                setIsCashError(false)
                setAccountType(newAccountType);
            }
        } else {
            setIsCashError(false)
            setAccountType(newAccountType);
        }
    };

    const handleDayTrade = (value) => {
        setDayTrade(value);
    };

    useEffect(() => {
        if (appData.account_type === "custodial") {
            setAccountType("cashAcc");
            setSelectedOption("level2");
            setSelectedLabel("level2");
        } else if (appData.account_type === "IRA") {
            setAccountType("cashAcc");
            setSelectedOption("level4");
            setSelectedLabel("level4");
        }

        if (appData.hear_about_us === "DAWUL") {
            setAccountType("marginAcc");
            setSelectedOption("level4");
            setSelectedLabel("level4");
        }

        if (financialInfo.assets === 'A') {
            setSelectedOption("level2");
            setSelectedLabel("level3");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appData.account_type, appData.hear_about_us, setAccountType, setSelectedOption, setSelectedLabel]);

    const handleRadioChange = (option) => {
        if (appData.hear_about_us === "DAWUL") {
            return;
        }

        setSelectedOption(option);
        setSelectedLabel(option);
    };

    return (
        <div className="flex">
            <div className="left_side">
                <img className="w-full" src={acc_landing_logo} alt=""/>
            </div>
            <div className="right_side">
                <div className="account_info flex flex-column">
                    <div className="flex justify-content-between align-items-baseline">
                        <div role="progressbar" id="combo" aria-label="progress" className="w-100">
                            <ProgressBar now={now} label={`${now}%`} visuallyHidden/>
                        </div>
                        <Logout/>
                    </div>

                    <p className="account_text text-center font-normal text-xl mt-3">{t('account.welcome')} {personalData.firstName} {personalData.lastName}. {t('account.option_trading')}</p>
                    <p className="account_privileges text-center font-normal uppercase pt-4 pb-4 m-0 text-lg">
                        {t('account.account_privileges')}
                    </p>
                    <p className="account_profile text-center text-base font-bold">{t('account.account_profile')}</p>
                    <div className="flex justify-content-center gap-6 m-auto">
                        {appData.account_type !== "custodial" && (
                            <div className="flex align-items-center gap-2">
                                <input
                                    type="radio"
                                    className="account_check w-1rem h-1rem"
                                    name="accountType"
                                    onChange={() => handleAccountChange('marginAcc')}
                                    checked={accountType === 'marginAcc'}
                                />
                                <label
                                    className="account_check_label text-center font-bold text-base text-center font-bold text-base"><CashMarginTooltip/></label>
                            </div>
                        )}

                        <div className="flex align-items-center gap-2">
                            <input
                                type="radio"
                                className="account_check w-1rem h-1rem"
                                name="accountType"
                                onChange={() => handleAccountChange('cashAcc')}
                                checked={accountType === 'cashAcc'}
                            />
                            <label
                                className="account_check_label text-center font-bold text-base"><CashTooltip/></label>
                        </div>
                    </div>
                    <div>
                        {
                            isCashError &&
                            <p className="text-red-500 text-center">{t('errors.liquid_error')}</p>
                        }
                    </div>

                    <p className="account_cash_text text-center font-base font-bold m-3 line-height-3">
                        {t('account.cash_margin_accounts')}
                    </p>

                    <div className="text-center m-auto mt-3">
                        <p className="text-black">
                            {t('account.day_trade1')}
                            <a className="no-underline text-black"
                               href="https://choicetrade-media.s3.us-east-1.amazonaws.com/forms/Day_Trading_Supplement.pdf"> {t('account.day_trade2')} </a>
                            {t('account.day_trade3')}
                        </p>

                        <div className="flex justify-content-center gap-4 m-0">
                            <div className="flex align-items-center gap-2 ml-5">
                                <input
                                    type="radio"
                                    className="account_check w-1rem h-1rem"
                                    name="dayTrade"
                                    onChange={() => handleDayTrade('N')}
                                    checked={dayTrade === 'N'}
                                />
                                <label
                                    className="account_check_label text-center font-bold text-base">{t('joint.no')}</label>
                            </div>

                            <div className="flex align-items-center gap-2">
                                <input
                                    type="radio"
                                    className="account_check w-1rem h-1rem"
                                    name="dayTrade"
                                    onChange={() => handleDayTrade('Y')}
                                    checked={dayTrade === 'Y'}
                                />
                                <label
                                    className="account_check_label text-center font-bold text-base">{t('joint.yes')}</label>
                            </div>
                        </div>
                    </div>

                    <p className="specific_account text-center md:text-lg text-base font-normal pt-5">
                        {t('account.specify_trading_level')}
                    </p>
                    <p className="specific_account_text font-normal text-center text-lg">
                        {t('account.option_trading_level')}
                    </p>
                    <p className="choose_account font-normal text-center text-lg">
                        {t('account.choose_one')}
                    </p>
                    <div className="flex flex-column pb-5 m-auto gap-2">
                        <div className="flex align-items-center gap-2">
                            <input type="radio" className="account_check w-1rem h-1rem"
                                   onChange={() => handleRadioChange("level1")}
                                   checked={selectedOption === "level1"}
                            />
                            <label
                                className="account_check_label text-center font-bold text-base">{t('account.level1')}</label>
                        </div>
                        <div className="flex align-items-center gap-2">
                            <input type="radio" className="account_check w-1rem h-1rem"
                                   checked={selectedOption === "level2"}
                                   onChange={() => handleRadioChange("level2")}
                            />
                            <label
                                className="account_check_label text-center font-bold text-base">{t('account.level2')}</label>
                        </div>
                        <div className="flex align-items-center gap-2">
                            <input type="radio" className="account_check w-1rem h-1rem"
                                   onChange={() => handleRadioChange("level3")}
                                   checked={selectedOption === "level3"}
                            />
                            <label
                                className="account_check_label text-center font-bold text-base">{t('account.level3')}</label>
                        </div>
                        <div className="flex align-items-center gap-2">
                            <input type="radio"
                                   className="account_check w-1rem h-1rem"
                                   onChange={() => handleRadioChange("level4")}
                                   checked={selectedOption === "level4"}
                            />
                            <label
                                className="account_check_label text-center font-bold text-base">{t('account.level4')}</label>
                        </div>
                        <div className="flex align-items-center gap-2">
                            <input type="radio" className="account_check w-1rem h-1rem"
                                   disabled={true}
                                   onChange={() => handleRadioChange("level5")}
                                   checked={selectedOption === "level5"}
                            />
                            <label
                                className="account_check_label text-center font-bold text-base">{t('account.level5')}</label>
                        </div>
                        <div className="flex align-items-center gap-2">
                            <input type="radio" className="account_check w-1rem h-1rem"
                                   onChange={() => handleRadioChange("level0")}
                                   checked={selectedOption === "level0"}
                            />
                            <label
                                className="account_check_label text-center font-bold text-base">{t('account.level6')}</label>
                        </div>
                    </div>

                </div>
                <div
                    className="w-10 flex sm:justify-content-between justify-content-center align-items-center gap-2 sm:flex-row flex-column-reverse row-gap-3 pt-6 m-auto">
                    <Link className="no-underline" to={backTo}>
                        <button className="back_btn">{t('back_btn')}</button>
                    </Link>
                    <Link to="/experience" className="no-underline">
                        <button className="continue_btn" type="submit">{t('next_btn')}</button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    accountType: state.account.accountType,
    dayTrade: state.account.dayTrade,
    selectedOption: state.account.selectedOption,
    selectedLabel: state.account.selectedLabel,
    appData: state.appData,
    personalData: state.personalData,
    financialInfo: state.financialInfo
});

const mapDispatchToProps = {
    setAccountType,
    setDayTrade,
    setSelectedOption,
    setSelectedLabel,
    setPersonalData
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountInfo);